module.exports = "<p>\n  testimonials page coming soon!\n</p>\n"